<div class="loginContainer">
    <div *ngIf="errorMessage">{{errorMessage}}</div>
    <form (submit)="onLogin()" #theForm="ngForm" novalidate>
        <div>
            <h2>Inicio de sesion</h2>
        </div>
        <div>
            <label for="username"><b>Usuario: </b></label>
            <input type="text" name="username" placeholder="Ingrese nombre de usuario" [(ngModel)]="creds.username" #username="ngModel" required/>
            <div class="text-danger" *ngIf="username.toucheed && username.invalid && username.errors.required">UserName is required</div>
        </div>
        <div>
            <label for="password"><b>Contraseña:</b></label>
            <input type="password" name="password" placeholder="Ingrese contraseña" [(ngModel)]="creds.password" #password="ngModel" required/>
            <div class="text-danger" *ngIf="password.toucheed && password.invalid && password.errors.required">Password is required</div>

        </div>
        <div>
            <input type="submit" value="Login" [disabled]="theForm.invalid"/>

        </div>
        <div>
            <span class="psw"><a href="#">Olvido su contraseña?</a></span>
        </div>
    </form>
</div>
